import {computed,ref} from 'vue'
import {useStore} from 'vuex'

import { clickOutsideElement } from '../../foundation/js/clickoutside'


export default {
    name: "SortingComponent",
    setup(){
        const store = useStore()


        const sortingOptions = computed(()=>store.state.productSearch.sorting_options)
        const selectSort = (option) => {
            store.dispatch('productSearch/sortProducts',option)
        }

        const sortDropdownOpen = ref(false)
        const toggleSortingDropdown = () => {
            sortDropdownOpen.value = !sortDropdownOpen.value
            clickOutsideElement( ()=>{
                sortDropdownOpen.value = false
            } )()
        }
        const sortClassModifier = computed(()=> sortDropdownOpen.value ? 'nlx-sorting-component__sort--open' : '')

        const activeSortOption = computed( ()=>{
            return sortingOptions.value.find(option => option.selected)
        } )

        const getLabel = (labelRequested) => {
            return store.getters['labels/getLabel'](labelRequested)
        }

        return {
            activeSortOption,
            getLabel,
            toggleSortingDropdown,
            selectSort,
            sortClassModifier,
            sortingOptions,
            
        }
    }
}